import React, { useState, useEffect, useRef } from "react";
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const RoundToNearestHundred = () => {
  const [currentNumber, setCurrentNumber] = useState(0);
  const [userAnswer, setUserAnswer] = useState("");
  const [feedback, setFeedback] = useState("");
  const [isCorrect, setIsCorrect] = useState(null);
  const [showNext, setShowNext] = useState(false);
  const [feedbackClass, setFeedbackClass] = useState("");
  const [inactive, setInactive] = useState(false);
  const inputRef = useRef(null);
  const timerRef = useRef(null);

  // 🎤 Funny voice function
  const speak = (text) => {
    if ("speechSynthesis" in window) {
      const msg = new SpeechSynthesisUtterance(text);
      msg.pitch = 1.6; // funny higher pitch
      msg.rate = 1.2;  // a little faster
      const voices = speechSynthesis.getVoices();
      msg.voice =
        voices.find((v) =>
          v.name.includes("Fred") || v.name.includes("Google UK English Male")
        ) || voices[0];
      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(msg);
    }
  };

  // 🎲 Get random 3-digit number
  const getRandom3DigitNumber = () => Math.floor(Math.random() * 600) + 200;

  const roundToNearestHundred = (n) => Math.round(n / 100) * 100;

  const generateQuestion = () => {
    const num = getRandom3DigitNumber();
    setCurrentNumber(num);
    setUserAnswer("");
    setFeedback("");
    setIsCorrect(null);
    setShowNext(false);
    setFeedbackClass("");
    setInactive(false);
    inputRef.current?.focus();
    resetTimer();
  };

  const checkAnswer = () => {
    const parsedAnswer = parseInt(userAnswer, 10);
    const correct = roundToNearestHundred(currentNumber);

    if (isNaN(parsedAnswer)) {
      setFeedback("❗ Please enter a number.");
      setFeedbackClass("incorrect");
      setIsCorrect(false);
      resetTimer();
      return;
    }

    if (parsedAnswer === correct) {
      const successMessages = [
        `Awesome! ${currentNumber} becomes ${correct}!`,
        ` Correct! ${currentNumber} rounds up to ${correct}.`,
        ` Smart! ${correct} is the right rounding.`,
      ];
      const randomMsg =
        successMessages[Math.floor(Math.random() * successMessages.length)];

      setFeedback(randomMsg);
      setIsCorrect(true);
      setShowNext(true);
      setFeedbackClass("correct");

      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      setFeedback(` Oops! ${userAnswer} isn’t correct. Try again!`);
      setIsCorrect(false);
      setFeedbackClass("incorrect");
    }
    resetTimer();
  };

  // 🕒 Collapse timer
  const resetTimer = () => {
    clearTimeout(timerRef.current);
    setInactive(false);
    timerRef.current = setTimeout(() => {
      setInactive(true);
    }, 20000);
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  useEffect(() => {
    if (feedback) speak(feedback);
  }, [feedback]);

  return (
    <div
      className={`game-container ${inactive ? "collapsed" : ""}`}
      style={{
        margin: 0,
        fontFamily: "Comic Sans MS, sans-serif",
        background: "linear-gradient(to right,rgb(0, 0, 0), #ade8f4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        transition: "all 0.6s ease",
        opacity: inactive ? 0.4 : 1,
        transform: inactive ? "scale(0.9)" : "scale(1)",
      }}
      onClick={resetTimer}
      onKeyDown={resetTimer}
    >
      <div
        style={{
          background: "white",
          borderRadius: 20,
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
          padding: "30px 40px",
          textAlign: "center",
          width: 420,
        }}
      >
        <h2 style={{ color: "#0077b6", marginBottom: 20 }}>
          Round to Nearest 100
        </h2>

        {/* 🎭 Avatar reactions */}
        <img
          src={
            feedbackClass === "correct"
              ? "https://avataaars.io/?avatarStyle=Transparent&topType=Hat&accessoriesType=Kurt&facialHairType=BeardLight&facialHairColor=Auburn&clotheType=ShirtCrewNeck&clotheColor=Blue01&eyeType=EyeRoll&eyebrowType=FlatNatural&mouthType=Smile&skinColor=Brown"
              : feedbackClass === "incorrect"
              ? "https://avataaars.io/?avatarStyle=Transparent&topType=Hat&accessoriesType=Blank&facialHairType=BeardLight&facialHairColor=Auburn&clotheType=ShirtCrewNeck&clotheColor=Blue01&eyeType=EyeRoll&eyebrowType=FlatNatural&mouthType=Sad&skinColor=Brown"
              : 
              "https://avataaars.io/?avatarStyle=Transparent&topType=Hat&accessoriesType=Sunglasses&hairColor=Blue&facialHairType=BeardLight&facialHairColor=Auburn&clotheType=ShirtCrewNeck&clotheColor=Blue01&eyeType=EyeRoll&eyebrowType=FlatNatural&mouthType=Serious&skinColor=Brown"
          }
          alt="character"
          style={{ width: 120, height: 120, margin: "0 auto 20px" }}
        />

        <div style={{ fontSize: "1.5rem", marginBottom: 20, color: "#023047" }}>
          What is {currentNumber} rounded to the nearest hundred?
        </div>

        <input
          ref={inputRef}
          type="number"
          value={userAnswer}
          onChange={(e) => setUserAnswer(e.target.value)}
          placeholder="Enter answer"
          style={{
            fontSize: "1.5rem",
            padding: "8px 15px",
            borderRadius: 12,
            border: "3px solid #004d40",
            width: "100%",
            textAlign: "center",
            outline: "none",
            marginBottom: 20,
          }}
          disabled={isCorrect}
          onKeyDown={(e) => e.key === "Enter" && checkAnswer()}
        />

        {!showNext && (
          <button
            style={{
              fontSize: "1rem",
              padding: "10px 18px",
              border: "none",
              background: "#0077b6",
              color: "white",
              borderRadius: 25,
              cursor: "pointer",
              margin: 5,
            }}
            onClick={checkAnswer}
          >
            Check
          </button>
        )}
        {showNext && (
          <button
            style={{
              fontSize: "1rem",
              padding: "10px 18px",
              border: "none",
              background: "#d62828",
              color: "white",
              borderRadius: 25,
              cursor: "pointer",
              margin: 5,
            }}
            onClick={generateQuestion}
          >
            Try Another
          </button>
        )}

        <div
          style={{
            fontSize: "1.2rem",
            marginTop: 10,
            minHeight: 30,
            fontWeight: 700,
            color:
              feedbackClass === "correct"
                ? "#2d6a4f"
                : feedbackClass === "incorrect"
                ? "#b00020"
                : "#023047",
          }}
        >
          {feedback}
        </div>
      </div>
    </div>
  );
};

export default RoundToNearestHundred;
